'use client'
import { defineSlotRecipe } from '@chakra-ui/react'
import { accordionAnatomy } from '@chakra-ui/react/anatomy'

const buttonColor = {
    light: 'var(--chakra-colors-white)',
    dark: 'var(--chakra-colors-dark-800)',
}

const panelColor = {
    light: 'rgba(84, 79, 64, 0.08)',
    dark: 'rgba(190, 190, 189, 0.08)',
}

export const accordionSlotRecipe = defineSlotRecipe({
    slots: accordionAnatomy.keys(),
    base: {
        itemTrigger: {
            _enabled: {
                cursor: 'pointer',
            },
        },
    },
    variants: {
        variant: {
            base: {
                itemTrigger: {
                    _enabled: {
                        cursor: 'pointer',
                    },
                    paddingBlock: '0',
                    paddingBottom: '0',

                    paddingInline: '2',
                    transition: 'background-color 100ms linear',
                    _light: {
                        backgroundColor: buttonColor.light,
                        _hover: {
                            backgroundColor: panelColor.light,
                        },
                    },
                    _dark: {
                        backgroundColor: buttonColor.dark,
                        _hover: {
                            backgroundColor: panelColor.dark,
                        },
                    },
                },
            },
            conversationList: {
                itemTrigger: {
                    paddingInline: '8px',
                    _hover: {
                        _light: {
                            backgroundColor: 'dark.50',
                        },
                    },
                },
                itemContent: {
                    overflow: 'visible',
                },
            },
            translations: {
                root: {
                    border: 'none',
                },
                item: {
                    borderTopWidth: '1px',
                    '&:first-of-type': {
                        borderTop: 'none',
                    },
                },
                itemContent: {
                    border: 'none',
                },
            },
            gigiOutline: {
                root: {
                    border: 0,
                },
                itemTrigger: {
                    paddingLeft: '0',
                    _light: {
                        backgroundColor: buttonColor.light,
                        _hover: {
                            backgroundColor: panelColor.light,
                        },
                    },
                    _dark: {
                        backgroundColor: buttonColor.dark,
                        _hover: {
                            backgroundColor: panelColor.dark,
                        },
                    },
                },
                itemContent: {
                    _light: {
                        backgroundColor: panelColor.light,
                        _hover: {
                            backgroundColor: panelColor.light,
                        },
                    },
                    _dark: {
                        backgroundColor: panelColor.dark,
                        _hover: {
                            backgroundColor: panelColor.dark,
                        },
                    },
                },
            },
        },
    },
})
